var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.37872 12.5227C9.20375 12.2006 8.86656 12 8.5 12C8.13344 12 7.79625 12.2006 7.62128 12.5227L6.88256 13.8826L5.52267 14.6213C5.20056 14.7963 5 15.1334 5 15.5C5 15.8666 5.20056 16.2037 5.52267 16.3787L6.88256 17.1174L7.62128 18.4773C7.79625 18.7994 8.13344 19 8.5 19C8.86656 19 9.20375 18.7994 9.37872 18.4773L10.1174 17.1174L11.4773 16.3787C11.7994 16.2037 12 15.8666 12 15.5C12 15.1334 11.7994 14.7963 11.4773 14.6213L10.1174 13.8826L9.37872 12.5227Z",
    fill: "#011235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 8.5C23 12.4795 19.901 15.7349 15.9846 15.9846C15.7349 19.901 12.4795 23 8.5 23C4.35772 23 1 19.6423 1 15.5C1 11.5205 4.09898 8.26514 8.0154 8.0154C8.26513 4.09898 11.5205 1 15.5 1C19.6423 1 23 4.35772 23 8.5ZM10.0108 8.15191C12.9376 8.75162 15.2484 11.0624 15.8481 13.9892C18.7236 13.8096 21 11.4208 21 8.5C21 5.46229 18.5377 3 15.5 3C12.5792 3 10.1904 5.27639 10.0108 8.15191ZM8.95094 10.0177C9.11516 10.0309 9.27738 10.0514 9.43728 10.0789C11.8793 10.4986 13.7801 12.5412 13.9823 15.049C13.9922 15.2172 14 15.3661 14 15.5C14 18.5377 11.5377 21 8.5 21C5.46229 21 3 18.5377 3 15.5C3 12.4623 5.46229 10 8.5 10C8.63386 10 8.78278 10.0078 8.95094 10.0177Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssets);
export default __webpack_public_path__ + "static/media/assets.ceebb108de3190d78af365ffbe51857d.svg";
export { ForwardRef as ReactComponent };